import {
  getSelectedDistrict,
  getSelectedSport,
  selectWidgetTitle,
  selectWidgetTitleFontSize,
} from 'app/imports/App.selectors'
import IconLogo from 'assets/img/logo_small.png'
import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import * as Styled from './LayoutHeader.styled'

export function LayoutHeader() {
  const widgetTitle = useSelector(selectWidgetTitle)
  const widgetTitleFontSize = useSelector(selectWidgetTitleFontSize)
  const district = useSelector(getSelectedDistrict)
  const selectedSport = useSelector(getSelectedSport)

  const getTitleString = useCallback(() => {
    if (widgetTitle) {
      return widgetTitle
    }

    if (!district) return ''

    let result = district.name
    if (selectedSport) {
      result += ` ${selectedSport.name}`
    }

    return `${result}`
  }, [district, widgetTitle, selectedSport])

  const title = useMemo(() => {
    const value = getTitleString()
    return widgetTitle ? value : `${value} STANDING`
  }, [district, selectedSport])

  return (
    <Styled.HeaderContainer>
      <title>{`Standings | ${getTitleString()}`}</title>

      <Styled.TitleContainer>
        <Styled.LabelContainer>
          <Styled.Label>Presented by CSZ Network</Styled.Label>
          <Styled.Logo src={IconLogo} alt="" />
        </Styled.LabelContainer>

        <Styled.Title $size={widgetTitleFontSize}>{title}</Styled.Title>
      </Styled.TitleContainer>
    </Styled.HeaderContainer>
  )
}
